'use client';
import { createContext, useContext } from 'react';
import { publicRuntimeConfig } from '@utils/publicRuntimeConfig';

export type AppName = 'traeger' | 'meater';

interface AppContextValue {
  appName: AppName;
  isTraeger: boolean;
  isMeater: boolean;
}

const AppContext = createContext<AppContextValue>({
  appName: 'traeger',
  isTraeger: true,
  isMeater: false,
});

export const useApp = (): AppContextValue => {
  return useContext(AppContext);
};

interface AppProviderProps {
  children: React.ReactNode;
}

export const AppProvider = ({ children }: AppProviderProps) => {
  const appName: AppName = (publicRuntimeConfig as any)?.appName || 'traeger';
  const isTraeger = appName === 'traeger';
  const isMeater = appName === 'meater';

  const value: AppContextValue = {
    appName,
    isTraeger,
    isMeater,
  };

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

export default AppContext;